const optionBlock = document.getElementById('eye-cartOption');
const radiobtn = document.getElementsByName('attributes[配送希望日の指定]');
const radioLen = radiobtn.length;
const attributesDate = document.getElementById('eye-attributesDate');
const attributesTime = document.getElementById('eye-attributesTime');

function postData() {
  for (let i = 0; i < radioLen; i++){
    if (radiobtn.item(i).checked){
      var attributesSpecification = radiobtn.item(i).value;
    }
  }

  const attributesDateValue = attributesDate.value;
  const attributesTimeValue = attributesTime.value;
  const attributes = {
    attributes: {
      '配送希望日の指定': attributesSpecification,
      '配送希望日の日付': attributesDateValue,
      '配送希望日の時間': attributesTimeValue
    }
  };
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(attributes),
  })
    .then(response => response.json())
    .then(data => {
      // console.log('Success:', data);
    })
    .catch((error) => {
      // console.error('Error:', error);
    });
}

optionBlock.addEventListener('change', postData);